import {Component, Input} from '@angular/core';
import {SearchService} from '../../../../provider/search.service';

@Component({
  selector: 'kt-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent {
  @Input() noRecordText: string;

  constructor(public searchService: SearchService) {
  }
}
